<template>
  <div class="fg-component fg-home">
    <!-- featured Contest -->
    <div class="fg-home-menu-card waf-menu-card">
      <div class="fg-head">
        <h1 class="title">{{ translations.game_plan_label }}</h1>
      </div>
      <div class="fg-body">
        <div class="contest-list contest-listing">
          <contest-item
            v-for="(contestListItem, idx) in contest_list"
            :key="idx"
            :featuredContest="contestListItem"
            :translations="translations"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cssImport } from "../../assets/js/common";
import contestListingStore from "../../store/modules/contestListing/contestListingStore";
import ContestItem from "../common/contestItem";

export default {
  components: {
    ContestItem,
  },
  computed: {
    has_store_data() {
      let contestListingStore = !!(this.$store.state && this.$store.state.contest_listing_store);
      return !!( contestListingStore && this.contest_list && this.contest_list.length );
    },
    contest_list() {
      return this.$store.state.contest_listing_store.contestList;
    },
    translations() {
      return this.$store.state.translations;
    },
  },
  async serverPrefetch() {
    // serverPrefetch runs only on serverside
    this.$store.registerModule("contest_listing_store", contestListingStore);
    return await Promise.all([
      this.$store.dispatch("contest_listing_store/fetchContestListApi"),
    ]);
  },
  beforeMount() {
    this.registerStore();
  },
  mounted() {
    let hasStore = this.has_store_data;
    if (!hasStore) {
      cssImport(["/static-assets/css/home.css"]);
      this.callApis();
    }
  },
  methods: {
    registerStore() {
      let hascontestListingStore = this.$store.hasModule(
        "contest_listing_store"
      );
      if (!hascontestListingStore) {
        this.$store.registerModule(
          "contest_listing_store",
          contestListingStore,
          {
            preserveState: this.has_store_data,
          }
        );
      }
    },
    callApis() {
      this.$store.dispatch("contest_listing_store/fetchContestListApi");
    },
  },

  unmounted() {
    let hasHomeStore = this.$store.hasModule("contest_listing_store");
    if (hasHomeStore) {
      this.$store.unregisterModule("contest_listing_store");
    }
  },
};
</script>